<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>输入资产编码</span>
    </div>
    <div class="code-wrapper">
      <img class="code-img" src="../../../assets/images/asset-code.png">
      <div class="code-search">
        <input type="text" v-model="input_asset_num" placeholder="请准确输入资产条形码上的数字编码" />
        <div @click="checkCode()">盘点</div>
      </div>
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../../assets/images/loading.gif">
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AssetStocktakingEnterCode',
  metaInfo: {
    title: '输入资产编码'
  },
  data () {
    return {
      loading: false, // 加载动画
      stocktaking_id: 0,
      input_asset_num: '' // 盘点资产编码（扫码或录码结果）
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.stocktaking_id = this.$route.query.stocktaking_id
  },
  methods: {
    // 资产编码校验
    checkCode () {
      if (this.input_asset_num === '') {
        this.$toast({
          message: '未获取到资产编码',
          duration: 2000
        })
        return false
      }
      this.loading = true
      // 判断资产是否存在
      this.axios.post('/wechat/asset/assetDetail', {
        member_id: this.memberId,
        village_id: this.villageId,
        asset_num: this.input_asset_num
      }).then((res) => {
        if (res.data.status === 1) {
          this.loading = false
          var assetInfo = res.data.data
          if (assetInfo.status < 0) {
            this.$messagebox({
              message: '该资产已报废，无法盘点',
              closeOnClickModal: false,
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return false
          }
          // 判断资产是否在盘点单内
          this.axios.post('/wechat/stocktaking/getStocktakingInfo', {
            member_id: this.memberId,
            village_id: this.villageId,
            stocktaking_id: this.stocktaking_id,
            asset_id: assetInfo.asset_id
          }).then((res2) => {
            if (res2.data.status === 1) {
              this.loading = false
              var stocktakingInfo = res2.data.data.stocktaking_info
              if (assetInfo.storage_id !== stocktakingInfo.storage_id) {
                this.$messagebox({
                  message: '该资产不属于盘点仓库，无法盘点',
                  closeOnClickModal: false,
                  showCancelButton: false,
                  confirmButtonText: '确定'
                })
                return false
              }
              if (stocktakingInfo.goods.length > 0) {
                // 在盘点单内
                var detail = stocktakingInfo.goods[0]
                this.$router.push({name: 'AssetStocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
              } else {
                // 不在盘点单内
                this.$messagebox({
                  message: '该资产不在本次盘点范围，是否继续盘点',
                  closeOnClickModal: false,
                  showCancelButton: true,
                  confirmButtonText: '盘点'
                }).then(action => {
                  if (action === 'confirm') { // 确认的回调
                    var detail = {}
                    detail.asset_id = assetInfo.asset_id
                    detail.asset_num = assetInfo.asset_num
                    detail.goods_name = assetInfo.goods_name
                    detail.stocktake_status = 0
                    detail.old_area_id = assetInfo.area_id
                    detail.old_area_name = assetInfo.area_name
                    detail.old_keeper_member_id = assetInfo.keeper_member_id
                    detail.old_keeper_member_name = assetInfo.keeper_member_name
                    detail.old_status = assetInfo.status
                    detail.old_status_info = assetInfo.status_info
                    this.$router.push({name: 'AssetStocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
                  }
                })
              }
            }
          }).catch(() => {
            this.loading = false
            this.$toast({
              message: '网络错误',
              duration: 5000
            })
          })
        } else {
          this.loading = false
          this.$messagebox({
            message: '未找到编号' + this.input_asset_num + '资产，是否增加盘盈',
            closeOnClickModal: false,
            showCancelButton: true,
            confirmButtonText: '盘盈'
          }).then(action => {
            if (action === 'confirm') { // 确认的回调
              this.$router.push({name: 'AssetStocktakingProfit', query: {stocktaking_id: this.stocktaking_id, code_asset_num: this.input_asset_num}})
            }
          })
        }
      }).catch(() => {
        this.loading = false
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #ffffff;
}
.code-wrapper {
  text-align: center;
  padding: 25px;
}
.code-wrapper .code-search {
  margin-top: 20px;
  display: flex;
}
.code-wrapper .code-search input {
  flex: 1;
  height: 30px;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  padding: 0 10px;
}
.code-wrapper .code-search div {
  width: 50px;
  height: 28px;
  line-height: 28px;
  border: 1px solid #313131;
  margin-left: 10px;
  border-radius: 6px;
  font-size: 15px;
}
.code-wrapper .code-img {
  width: 117px;
  height: 117px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/AssetStocktaking/AssetStocktakingEnterCode.vue